const styles = (theme) => ({
  avatar: {
    height: 45,
    width: 45,
    backgroundColor: theme.palette.secondary.main,
    marginRight: theme.spacing(1),
  },
  popover: {
    width: 200,
  },
})

export default styles
